import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Communication } from '../../../graphql/comms.datatypes';

interface CommunicationData {
  communication: Communication
}

export const gqlCommunication = `
  id
  ident
  title
  body
  active
  communication_type
  log_code
  receiver
  mandatory

  triggerValues {
    id
    trigger_key
    trigger_value
  }
`;

export const GET_COMMUNICATION_QUERY = gql`
    query getCommunication($id: Int!){
        communication(id: $id){
          ${gqlCommunication}
        }
    }
`;

export const getCommunication = (commsId: string) => {
  const id = commsId ? Number.parseInt(commsId, 10) : -1;
  return useQuery<CommunicationData>(
    GET_COMMUNICATION_QUERY,
    {
      variables: {id}
    }
  );
}

export default getCommunication;
